import React, { memo, useState } from 'react';
import { Props, AtendenteProps } from './types';
import { Select, Tooltip } from 'antd';
import Justification from '../../Modal/Justification';
import { listaAtendentes } from '../services';
import { IModification } from '../../Modal/Justification/types';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import mask from 'utils/mask';

const SelectAtendente: React.FC<Props> = ({ protocolo, currentAttendant }) => {
  const { Option } = Select;
  const [response, setResponse] = useState<AtendenteProps[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [modification, setModification] = useState<IModification>();
  const [loading, setLoading] = useState<boolean>(false);
  const ocorrencia = useSelector((state: ApplicationState) => state.Ocorrencia?.data['ocorrencia']);

  const onClick = () => {
    if (response.length === 0) {
      setLoading(true);
      listaAtendentes.listaAtendentes().then((res) => {
        setResponse(res.data.atendentes);
        setLoading(false);
      });
    }
  };

  const onChange = (value: any): void => {
    setModification({
      codAtendente: value,
    });
    setOpen(true);
  };

  return (
    <>
      <Justification
        modification={modification}
        open={open}
        setOpen={setOpen}
        currentSolicitacao={ocorrencia?.tipoSolicitacao}
      />
      <Tooltip
        title={
          ocorrencia?.status !== 'AC'
            ? ''
            : 'Não é possível alterar o atendente de um atendimento finalizado'
        }
      >
        <Select
          data-cy="selectAttendant"
          onChange={onChange}
          onClick={onClick}
          disabled={ocorrencia?.status === 'AC'}
          showSearch
          optionFilterProp={'children'}
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          defaultValue={mask('camelCase', currentAttendant)}
          style={{ width: '100%' }}
          loading={loading}
        >
          {response?.map((item) => {
            if (item.nome === currentAttendant) return null;
            return (
              <Option value={item.codigo} key={item.codigo}>
                {mask('camelCase', item?.nome)}
              </Option>
            );
          })}
        </Select>
      </Tooltip>
    </>
  );
};

export default memo(SelectAtendente);
